import React from 'react';
import moment from 'moment';
import { Text } from 'components/tt-forms/common';
import { ContainerFileDinhKem } from 'components/upload';
import { ShowIf } from 'components/utils';

class ThongTinYeuCauKTDX extends React.Component {

  render() {

    let donViPhoiHop = '';
    if (this.props.thongTinYeuCauKiemTraDeXuat) {
      this.props.thongTinYeuCauKiemTraDeXuat.donViPhoiHops.map(item => {
        donViPhoiHop = donViPhoiHop + item.ten + ', ';
      });
    }

    donViPhoiHop = donViPhoiHop.slice(0, donViPhoiHop.length - 2);

    return (

      <div className="box-items">
        <div className="box-forward">
          <div className="container-box">
            <div className="group-box">
              <div className="title">
                <div className="row pl10 pr10">
                  <div className="col-12">
                    <h3>Thông tin yêu cầu kiểm tra đề xuất</h3>
                  </div>
                </div>
              </div>
              <div className="items-form mb0-18">
                <div className="row pl10 pr10 mb10">

                  <Text
                    className="col-25"
                    label="Đơn vị giao kiểm tra đề xuất:"
                    value={this.props.thongTinYeuCauKiemTraDeXuat && this.props.thongTinYeuCauKiemTraDeXuat.donViDuocGiaoTTXM ?
                      this.props.thongTinYeuCauKiemTraDeXuat.donViDuocGiaoTTXM.ten : ''} />

                  {/* <Text
                    className="col-25"
                    label="Đơn vị phối hợp:"
                    value={donViPhoiHop} /> */}

                  <Text
                    red={true}
                    className="col-25"
                    label="Thời gian báo cáo kết quả:"
                    value={this.props.thongTinYeuCauKiemTraDeXuat && this.props.thongTinYeuCauKiemTraDeXuat.ngayBaoCaoKQ ?
                    moment(this.props.thongTinYeuCauKiemTraDeXuat.ngayBaoCaoKQ).format('DD/MM/YYYY') : ''} />

                </div>
              </div>
              <ShowIf condition={this.props.showTable}>
                <div className="container-filedinhkem">
                  <ContainerFileDinhKem label="Danh sách văn bản xử lý" disableAttachFile={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuKiemTraDeXuat} />
                </div>
              </ShowIf>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

ThongTinYeuCauKTDX.defaultProps = {
}

export default ThongTinYeuCauKTDX;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-kiem-tra-de-xuat/ThongTinYeuCauKTDX.jsx